import { accountService } from "../Services";
import { storageHandler } from "./storage";
import { http } from "./http-common";

export const fetchWrapper = {
  get,
  post,
  put,
  patch,
  postFile,
  delete: _delete,
  getfileFordownload,
  postForStream,
};

function get(url) {
  const isCsv = url.indexOf("page[filetype]=csv") !== -1;
  const requestOptions = {
    method: "GET",
    headers: authHeader(url),
    ...(isCsv ? { responseType: "blob" } : {}),
  };

  return fetch(url, requestOptions)
    .then((res) => {
      if (!res.ok) {
        if (res?.status === 401 || res?.status === 401) {
          accountService.logout();
          return Promise.reject(new Error('Unauthorized'));
        }
        return res.text().then((text) => {
          throw new Error(text || `Request failed with status ${res.status}`);
        });
      }
      return isCsv ? handleBlobResponse(res) : handleResponse(res);
    })
    .catch((err) => {
      console.log("🚀 ~ get ~ err:", err)
      console.error("❌ GET request failed:", err.message || err);
      
      // Handle CORS and network errors gracefully
      if (err.name === 'TypeError' || err.message.includes('CORS') || err.message.includes('Failed to fetch')) {
        return Promise.reject(new Error("Network error. Please check your connection and try again."));
      }
      
      return Promise.reject(new Error(err.message || "Something went wrong, please try again later."));
    });
}

function getfileFordownload(url) {
  //if (url.indexOf('page[filetype]=csv') !== -1) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(url),
    responseType: "blob",
  };
  console.log("here");
  return fetch(url, requestOptions).then(handleBlobResponse);
  //}
}
function post(url, body) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...authHeader(url),
    },
    credentials: "include",
    body: JSON.stringify(body),
  };
  return fetch(url, requestOptions)
    .then((res) => {
      if (res?.status === 401) {
        accountService.logout();
        return Promise.reject(new Error('Unauthorized'));
      }
      return handleResponse(res);
    })
    .catch((err) => {
      console.error("❌ POST request failed:", err.message || err);
      if (err.name === 'TypeError' || err.message.includes('CORS') || err.message.includes('Failed to fetch')) {
        return Promise.reject(new Error("Network error. Please check your connection and try again."));
      }
      return Promise.reject(err);
    });
}

function postFile(url, formData, onUploadProgress) {
  return http
    .post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/json",
        ...authHeader(url),
      },
      credentials: "include",
      onUploadProgress,
    })
    .then(handleAxiosResponse).catch((err) => {
      console.error("❌ POST request failed:", err.message || err);
      return Promise.reject(err);
    })
}

function put(url, body) {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...authHeader(url),
    },
    body: JSON.stringify(body),
  };
  return fetch(url, requestOptions).then((res) => {
    if (res?.status === 401) {
      accountService.logout();
      return Promise.reject(new Error('Unauthorized'));
    }
    return handleResponse(res);
  });
}

function patch(url, body) {
  const requestOptions = {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...authHeader(url),
    },
    body: JSON.stringify(body),
  };
  return fetch(url, requestOptions).then((res) => {
    if (res?.status === 401) {
      accountService.logout();
      return Promise.reject(new Error('Unauthorized'));
    }
    return handleResponse(res);
  });
}


// prefixed with underscored because delete is a reserved word in javascript
function _delete(url) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(url),
  };
  return fetch(url, requestOptions).then((res) => {
    if (res.status === 401) {
      accountService.logout();
      return Promise.reject(new Error('Unauthorized'));
    }
    return handleResponse(res);
  });
}

// this code is for Owl chat
function postForStream(url, body) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...authHeader(url),
    },
    credentials: "include",
    body: JSON.stringify(body),
  };
  return fetch(url, requestOptions);
}

// helper functions
function authHeader(url) {
  const user =  accountService.userValue;
  // console.log("🚀 ~ authHeader ~ user:", user)
  const isLoggedIn = user && user.access_token;
  const isApiUrl = url.startsWith(process.env.REACT_APP_API_URL);
  if (isLoggedIn && isApiUrl) {
    return {
      Authorization: `Bearer ${storageHandler.getToken()|| user.access_token}`,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
  } else {
    // if not logged in get previous token and check if session is still active
    const token =  storageHandler.getToken();
    // console.log("🚀 ~ authHeader ~ token:", token)
    if (token) {
      return {
        Authorization: `Bearer ${token}`,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
    }
    return {};
  }
}
const decodeBase64Json = (encodedString) => {
  // Step 1: Decode the base64 string
  const decodedString = atob(encodedString); // This gives the raw JSON string

  // Step 2: Parse the JSON string to convert it back to a JavaScript object
  try {
    const jsonObject = JSON.parse(decodedString);
    return jsonObject;
  } catch (error) {
    console.error("Error parsing JSON:", error);
    return null; // Return null if there's an error
  }
};
function isBase64(str) {
  const base64Regex = /^(?:[A-Z0-9+\/]{4})*(?:[A-Z0-9+\/]{2}==|[A-Z0-9+\/]{3}=)?$/i;
  return base64Regex.test(str);
}
function handleResponse(response) {
  return response.text().then((text) => {
    let data;
    if (!isBase64(text)) {
      data = text && JSON.parse(text);
    } else {
      const decryptedResponse = text && decodeBase64Json(text);
      data = JSON.parse(decryptedResponse);
    }
    if (!response.ok) {
      if ([401].includes(response.status) && accountService.userValue) {
        // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
        accountService.logout();
      }
      if (data.message == "End Impersonation") {
        accountService.impersanationTimeExpires();
      }
      if (data.message == "Access Not Allowed") {
        accountService.redirectToActiveUser();
      }
      let errorMessage = "";

      if (data["error"]) {
        errorMessage = `Error: ${
          data["error"]["message"] || data["error"]["status"] || data["error"]
        }`;
      } else if (data["errors"]) {
        errorMessage = objToString(data["errors"]);
      } else {
        if (data && data.success == false && response.status && data.message) {
          return Promise.reject(new Error(data.message || "API request failed"));
        } else {
          errorMessage = (data && data.message) || response.statusText;
        }
      }

      return Promise.reject(new Error(errorMessage));
    }

    return data;
  });
}
function handleBlobResponse(response) {
  console.log(response);
  return response.text().then((text) => {
    const data = text;
    if (!response.ok) {
      if ([401].includes(response.status) && accountService.userValue) {
        // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
        accountService.logout();
      }
      const decryptedResponse = text && decodeBase64Json(text);
      const data = JSON.parse(decryptedResponse);
      let errorMessage = "";
      if (data["error"]) {
        errorMessage = `Error: ${
          data["error"]["message"] || data["error"]["status"] || data["error"]
        }`;
      } else if (data["errors"]) {
        errorMessage = objToString(data["errors"]);
      } else {
        if (data && data?.success == false) {
          return Promise?.reject(new Error(data.message || "Request failed"));
        } else {
          errorMessage = (data && data.message) || response.statusText;
        }
      }
      return Promise.reject(new Error(errorMessage));
    }

    return data;
  });
}
function objToString(obj) {
  let res = ``;
  for (var i in obj) {
    if (Array.isArray(obj[i])) {
      obj[i].forEach((item) => {
        res += `<p>${item}</p>`;
      });
    }
  }
  return res;
}

function handleAxiosResponse(response) {
  if (response.status !== 200) {
    if ([401, 403].includes(response.status) && accountService.userValue) {
      // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
      accountService.logout();
    }
    const error = (response && response.message) || response.statusText;
    return Promise.reject(new Error(error));
  }
  return response.data;
}
